(function () {
  'use strict';

  function showRecovery() {
    document.documentElement.classList.remove('gettmi-download-pending');
  }

  // Keep the existing QR URL as a router. Never use incoming query parameters
  // as destinations or override the customer's Shopify shopping country.
  function isAndroid() {
    return /android/i.test(navigator.userAgent || '') ||
      (navigator.userAgentData && navigator.userAgentData.platform === 'Android');
  }

  function supportedCountry(country) {
    return /^(GB|US|AU)$/.test(String(country || '').toUpperCase());
  }

  function appleDestination(link) {
    if (!link) return '';
    try {
      var url = new URL(link.href);
      if (url.protocol !== 'https:' || url.hostname !== 'apps.apple.com' ||
          url.username || url.password || url.port ||
          !/\/id6778977805\/?$/.test(url.pathname)) return '';
      // Country-neutral listing: Apple resolves its storefront independently.
      return 'https://apps.apple.com/app/id6778977805';
    } catch (error) {
      return '';
    }
  }

  function webDestination(link) {
    if (!link) return '';
    try {
      var url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin || url.username || url.password ||
          !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/.test(url.pathname)) return '';
      url.search = '';
      url.hash = '';
      // The existing desktop shell opens its mobile-web QR dialog for this
      // fixed intent; phones enter the shop and stop receiving app nudges.
      url.searchParams.set('gettmi_mobile_web', '1');
      return url.toString();
    } catch (error) {
      return '';
    }
  }

  function detectedCountry(web) {
    // A fresh scan can inherit Shopify's default GB market from the neutral QR
    // URL. Check Shopify's own location detection before offering the App Store.
    // This is a location hint, not access to the customer's Apple Account.
    if (!web || typeof window.fetch !== 'function') return Promise.resolve('');
    var endpoint = new URL(web);
    endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '/browsing_context_suggestions.json';
    endpoint.search = '?country[enabled]=true&language[enabled]=false';
    return new Promise(function (resolve) {
      var finished = false;
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      function finish(country) {
        if (finished) return;
        finished = true;
        window.clearTimeout(timer);
        resolve(country);
      }
      var timer = window.setTimeout(function () {
        finish('');
        if (controller) controller.abort();
      }, 1500);
      Promise.resolve().then(function () {
        return window.fetch(endpoint.toString(), {
          credentials: 'same-origin', cache: 'no-store',
          signal: controller ? controller.signal : undefined
        });
      }).then(function (response) {
        if (!response.ok) throw new Error('Country check unavailable');
        return response.json();
      }).then(function (data) {
        var country = data && data.detected_values && data.detected_values.country;
        finish(country && country.handle || '');
      }).catch(function () { finish(''); });
    });
  }

  function initialize(root) {
    if (root.dataset.gettmiDownloadReady === 'true') return;
    root.dataset.gettmiDownloadReady = 'true';
    // Keep the Shopify editor usable without navigating its preview iframe.
    if (root.dataset.designMode === 'true') {
      showRecovery();
      return;
    }

    var appleLink = root.querySelector('[data-gettmi-download-action="app_store"]');
    var apple = appleDestination(appleLink);
    var webLink = root.querySelector('[data-gettmi-download-action="mobile_web"]');
    var web = webDestination(webLink);
    if (web) webLink.href = web;
    function navigate(destination) {
      if (appleLink) appleLink.hidden = !apple || destination !== apple;
      if (!destination) {
        showRecovery();
        return;
      }
      try {
        // Keep recovery hidden throughout iOS's native confirmation. A timer
        // revealing it would paint text behind that dialog again.
        window.location.replace(destination);
      } catch (error) {
        showRecovery();
      }
    }

    if (isAndroid() || !supportedCountry(root.dataset.shoppingCountry) || !apple) {
      navigate(web);
      return;
    }
    detectedCountry(web).then(function (country) {
      // Unknown, unsupported, failed and timed-out checks all have a usable
      // destination. Never send them to an unavailable App Store listing.
      navigate(supportedCountry(country) ? apple : web);
    });
  }

  document.querySelectorAll('[data-gettmi-download]').forEach(initialize);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-gettmi-download]').forEach(initialize);
  });
})();
